class LikeButton extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.apiUrl = (this.dataset.apiUrl || '').replace(/\/$/, '');
    this.button = this.querySelector('.like-button__btn');
    this.countEl = this.querySelector('.like-button__count');
    this.storageKey = `mp-liked-${this.productId}`;

    if (!this.apiUrl || !this.productId) {
      this.hidden = true;
      return;
    }

    this.fetchCount();

    if (window.localStorage.getItem(this.storageKey)) {
      this.setLiked(true);
    }

    this.button.addEventListener('click', () => this.handleClick());
  }

  async fetchCount() {
    try {
      const response = await fetch(`${this.apiUrl}/like?productId=${encodeURIComponent(this.productId)}`);
      const data = await response.json();
      this.countEl.textContent = data.count ?? 0;
    } catch (error) {
      this.countEl.textContent = '';
    }
  }

  async handleClick() {
    if (this.button.disabled) return;
    if (window.localStorage.getItem(this.storageKey)) return;

    this.button.disabled = true;

    try {
      const response = await fetch(`${this.apiUrl}/like?productId=${encodeURIComponent(this.productId)}`, {
        method: 'POST',
      });
      const data = await response.json();
      this.countEl.textContent = data.count ?? '';
      window.localStorage.setItem(this.storageKey, '1');
      this.setLiked(true);
    } catch (error) {
      this.button.disabled = false;
    }
  }

  setLiked(liked) {
    this.button.classList.toggle('is-liked', liked);
    this.button.setAttribute('aria-pressed', String(liked));
    this.button.disabled = liked;
  }
}

if (!customElements.get('like-button')) {
  customElements.define('like-button', LikeButton);
}